import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Box, Typography, Paper, IconButton } from "@mui/material";
import { deleteSEO, getSEO } from "../../redux/Slices/extSlice";

import EditImg from "../../assets/icons/edit_icon.png";
import DeleteImg from "../../assets/icons/delete_icon.png";

export default function DataTable({ rows, setUpdate }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const notify = (value) =>
    toast.success(value, { position: "top-right", theme: "light" });

  const handleDelete = (id) => {
    dispatch(deleteSEO({ id }))
      .then(() => {
        dispatch(getSEO());
        notify("Successfully Deleted");
      })
      .catch((err) => console.log(err));
  };

  const editSeo = (id, title, desc, page) => {
    navigate(`/seo/${id}`, {
      state: { title, desc, page },
    });
  };

  const columns = [
    { field: "title", headerName: "Title", flex: 1 },
    { field: "desc", headerName: "Description", flex: 1 },
    { field: "page", headerName: "Page", flex: 1 },
    {
      field: "action",
      headerName: "Action",
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Box>
          <IconButton
            onClick={() =>
              editSeo(
                params.row.id,
                params.row.title,
                params.row.desc,
                params.row.page
              )
            }
          >
            <Box
              component="img"
              src={EditImg}
              alt="Edit"
              sx={{ width: 26, height: 26 }}
            />
          </IconButton>

          <IconButton onClick={() => handleDelete(params.row.id)}>
            <Box
              component="img"
              src={DeleteImg}
              alt="Delete"
              sx={{ width: 26, height: 26 }}
            />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Box sx={{ pl: { xs: 0, md: "17%" }, pt: "90px" }}>
      {/* Heading */}
      <Typography
        variant="h5"
        fontWeight={600}
        sx={{ mb: 3, pl: { xs: 2, md: 10 } }}
      >
        SEO List
      </Typography>

      {/* Table Wrapper */}
      <Paper
        elevation={0}
        sx={{
          border: "1px solid #e5e5e5",
          borderRadius: "14px",
          p: 2,
          width: "90%",
          mx: "auto",
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          disableRowSelectionOnClick
          autoHeight
          columnBuffer={0}
          columnThreshold={0}
          sx={{
            border: "none",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#f2f1ff",
              color: "#1b1b1b",
              fontWeight: "700",
              fontSize: "15px",
            },
            "& .MuiDataGrid-cell": {
              backgroundColor: "#fafaff",
              fontSize: "14px",
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
            },
          }}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 5 },
            },
          }}
          pageSizeOptions={[5, 10]}
          checkboxSelection
        />
      </Paper>

      <ToastContainer />
    </Box>
  );
}
